
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { Hint } from '@drawbotics/react-drylus';
import Playground from '~/components/Playground';


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


<h1>{`Hint`}</h1>
<p>{`Used to display hints or errors on form elements. You should `}<strong parentName="p">{`never`}</strong>{` have to use this in anything other than complex `}<inlineCode parentName="p">{`FormGroups`}</inlineCode>{`, if you need to set a hint to a form element use the `}<inlineCode parentName="p">{`hint`}</inlineCode>{` or `}<inlineCode parentName="p">{`error`}</inlineCode>{` props already provided. It sets its own margin on top, so no need to set that yourself.`}</p>
<pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { Hint } from '@drawbotics/react-drylus';
`}</code></pre>
<p><strong parentName="p">{`Example`}</strong></p>
<Playground __position={0} __code={`<Hint>This is a hint</Hint>`} component={Hint} mdxType="Playground">
  <Hint mdxType="Hint">This is a hint</Hint>
</Playground>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;